import { buildRoleSet } from '../../reducers/users/roles';
import { _noOpProvider } from './base-provider';
import mixpanelBrowser from 'mixpanel-browser';
let globalUserId;
const setUserOrgs = (context)=>{
    return context.contexts.map((context)=>context.organizationCode.toString());
};
export const mixpanelFactory = ()=>{
    let initialized = false;
    return {
        ..._noOpProvider,
        initialize: (config)=>{
            if (!initialized && config?.mixpanelApiKey !== undefined) {
                initialized = true;
                mixpanelBrowser.init(config.mixpanelApiKey, {
                    api_host: window.location.origin,
                    debug: true
                });
            }
        },
        setContext: (context)=>{
            if (!initialized) {
                return;
            }
            const activeRoles = buildRoleSet(context);
            const activeOrg = context.activeContext?.organizationCode;
            const availableOrgs = setUserOrgs(context);
            const { user } = context;
            mixpanelBrowser.people.set({
                'Recently Active Roles': activeRoles,
                'Recently Active Organization': activeOrg,
                'Available Organizations': availableOrgs
            });
            mixpanelBrowser.people.set_once({
                $name: user.firstName + ' ' + user.lastName,
                $email: user.username
            });
        },
        setUser: (user)=>{
            if (!initialized) {
                return;
            }
            if (user.id && user.id !== globalUserId) {
                globalUserId = user.id;
                mixpanelBrowser.identify(`${user.id}`);
            }
        },
        trackView: (viewName)=>{
            if (!initialized) {
                return;
            }
            mixpanelBrowser.track(typeof viewName === 'string' ? viewName : viewName.name, {});
        },
        handleAction: (action, data)=>{
            if (!initialized) {
                return;
            }
            if (!action.meta?.analytics) {
                return;
            }
            const actionType = action.type.replace(/[-_]/g, ' ');
            mixpanelBrowser.track(actionType, {});
        },
        reset: ()=>{
            if (!initialized) {
                return;
            }
            mixpanelBrowser.reset();
        }
    };
};
